<template>
  <div v-if="data && data.type === 'RADIO'" class="options-wrapper">
    <!-- <div class="title">{{ data.title }} {{ data.description }}</div> -->
    <div>
      <div
        v-for="(item, index) in data.options"
        :key="item.code"
        class="option"
        :class="{ active: index === activeIndex }"
        @click="onChoose(item, index)"
      >
        {{ item.content }}
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { Vue, Component, Prop } from 'vue-property-decorator';
import Popup from '@component/Popup/';
import { IQuestion, IAnswerItem, IOption } from './types';

@Component({
  components: { Popup },
})
export default class Questionnaire extends Vue {
  @Prop({}) data!: IQuestion;
  @Prop({}) answer!: IAnswerItem;

  activeIndex: number | null = null;

  mounted() {
    if (this.data && this.answer) {
      const answerCode = this.answer.options![0].code;

      const index = this.data.options.findIndex((item: IOption) => {
        return item.code === answerCode;
      });
      if (index !== -1) {
        this.activeIndex = index;
      }
    }
  }

  onChoose(item: IOption, index: number) {
    this.activeIndex = index;
    this.$emit('onChoose', this.data, item);
  }
}
</script>

<style lang="scss" scoped vars="{ques-theme-bg, ques-theme-bg-opacity}">
$theme-color: var(--ques-theme-bg);
$theme-color-opacity: var(--ques-theme-bg-opacity);

.options-wrapper {
  width: 100vw;
  padding: 0 42px;
}
.title {
  margin-bottom: 24px;
  color: #382d68;
  font-weight: bold;

  font-size: 30px;
  line-height: 42px;
  text-align: center;
}
.option {
  box-sizing: border-box;
  width: 100%;
  height: 94px;
  margin-bottom: 24px;
  overflow: hidden;
  color: #382d68;

  font-size: 28px;
  line-height: 94px;
  text-align: center;
  background-color: #f5f5fb;
  border: 2px solid #f5f5fb;
  border-radius: 8px;
}
.active {
  background-color: $theme-color-opacity;
  border-color: $theme-color;
}
</style>
